import { globalApi as api } from '../../api';

export const createPermission = async (AddPermission) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/permission', AddPermission,

      {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  }  catch (error) {
    throw ( error.response?.data?.message || error.response?.data?.error || error.message || "An error occurred");
  }
};


export const fetchPermission = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/permissions', {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const updatePermission = async (id, updatePermissionData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/permission/${id}`, updatePermissionData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deletePermission = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/permission/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};



export const access_configuration = async (AddAccessConfiguration) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/access_configuration', AddAccessConfiguration, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    throw error.response ? error.response.data.message : error.message;
  }
};







